import { render, staticRenderFns } from "./PagePartner.vue?vue&type=template&id=45545a57&scoped=true"
import script from "./PagePartner.vue?vue&type=script&lang=js"
export * from "./PagePartner.vue?vue&type=script&lang=js"
import style0 from "./PagePartner.vue?vue&type=style&index=0&id=45545a57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45545a57",
  null
  
)

export default component.exports